module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i4zRs"))).then(() => parcelRequire('ikE14'));